import { darken, makeStyles } from '@material-ui/core';

export default makeStyles(
  ({
    palette: {
      common: { white },
    },
  }) => ({
    root: {
      zIndex: 1300,
    },

    actions: {
      '& > *': {
        margin: 2,
        width: 100,
      },
    },

    cancel: {
      backgroundColor: white,

      '&:hover': {
        backgroundColor: darken(white, 0.05),
      },
    },
  }),
);
